import en from "./locales/en.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";

const flatten = (obj, prefix = "", res = {}) => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = prefix ? `${prefix}.${key}` : key;
      if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
        flatten(obj[key], newKey, res);
      } else {
        res[newKey] = obj[key];
      }
    }
  }
  return res;
};

const messages = {
  en: flatten(en),
  es: flatten(es),
  pt: flatten(pt),
};

export function getMessages(locale) {
  return messages[locale] || messages.en;
}
